import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles, useTheme } from '@material-ui/core/styles';
import { ClickAwayListener, FormControl, InputLabel, MenuItem, MenuList, Select, Typography, IconButton, DialogActions } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import useMediaQuery from '@material-ui/core/useMediaQuery';


import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import PrintIcon from '@material-ui/icons/Print';

const soundOptions = [
  {
    title: 'Hinweis',
    name: 'alert.mp3',
  },
  {
    title: 'Glocke',
    name: 'service_bell.mp3',
  },
  {
    title: 'Glocke 2',
    name: 'bell.mp3',
  },
  {
    title: 'Klingeln',
    name: 'chime.mp3',
  },
  {
    title: 'Alarm',
    name: 'alarm_clock.mp3',
  },
  {
    title: 'Feueralarm',
    name: 'fire_alarm.mp3',
  },
  {
    title: 'Kein Ton',
    name: 'none',
  },
];

function SettingsDialog({ classes, onClose, localSettings, changeLocalSettings, open, resetOrderHistory, playSound, proceedAllVisibleOrders }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const backButton = (
    <Button
      color="primary"
      onClick={onClose}
    >
      Zurück
    </Button>
  );

  return (
    <Dialog
      fullScreen={fullScreen}
      classes={{ paper: 'printDialog' }}
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Einstellungen</DialogTitle>
      <DialogContent>
        <div >
          <Grid
            container
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={10}>
              <Typography className={classes.heading}>Netzwerk-Drucker</Typography>
            </Grid>

            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.useEposPrinter}
                onChange={ev => changeLocalSettings('useEposPrinter', ev.target.checked)}
                color="primary"
              />
            </Grid>
            {localSettings.useEposPrinter ? (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="IPv4 Adresse"
                    value={localSettings.ePosPrinterIP}
                    onChange={ev => changeLocalSettings('ePosPrinterIP', ev.target.value)}
                    disabled={!localSettings.useEposPrinter}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Port"
                    value={localSettings.ePosPrinterPort}
                    onChange={ev => changeLocalSettings('ePosPrinterPort', ev.target.value)}
                    disabled={!localSettings.useEposPrinter}
                  />
                </Grid>

                <Grid item xs={10}>
                  <Typography >Neue Bestellungen automatisch drucken</Typography>
                </Grid>
                <Grid
                  item
                  xs={2}
                  className={classes.switchContainer}
                >
                  <Switch
                    disabled={!localSettings.useEposPrinter}
                    checked={!!localSettings.autoprintNewOrders}
                    onChange={ev => changeLocalSettings('autoprintNewOrders', ev.target.checked)}
                    color="primary"
                  />
                </Grid>
                <Grid item xs={10}>
                  <Typography >Gesamtpreise drucken</Typography>
                </Grid>
                <Grid
                  item
                  xs={2}
                  className={classes.switchContainer}
                >
                  <Switch
                    disabled={!localSettings.useEposPrinter}
                    checked={localSettings.printTotalPrice}
                    onChange={ev => changeLocalSettings('printTotalPrice', ev.target.checked)}
                    color="primary"
                  />
                </Grid>
                <Grid item xs={10}>
                  <Typography >Artikelpreise drucken</Typography>
                </Grid>
                <Grid
                  item
                  xs={2}
                  className={classes.switchContainer}
                >
                  <Switch
                    disabled={!localSettings.useEposPrinter}
                    checked={localSettings.printArticlePrice}
                    onChange={ev => changeLocalSettings('printArticlePrice', ev.target.checked)}
                    color="primary"
                  />
                </Grid>
                <Grid item xs={10}>
                  <Typography >Neue Bestellung doppelt drucken</Typography>
                </Grid>
                <Grid
                  item
                  xs={2}
                  className={classes.switchContainer}
                >
                  <Switch
                    checked={localSettings.printOrderTwice}
                    onChange={ev => changeLocalSettings('printOrderTwice', ev.target.checked)}
                    color="primary"
                  />
                </Grid>
              </>)
              : null}
            <Grid item xs={10}>
              <Typography className={classes.heading}>Druckservice</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={!!localSettings.printViaService}
                onChange={ev => changeLocalSettings('printViaService', ev.target.checked)}
                color="primary"
              />
            </Grid>
            {localSettings.printViaService ? 
              (
                <>
                <Grid item xs={12}>
                  <TextField
                    label="Drucker ID"
                    value={localSettings.printerId}
                    onChange={ev => changeLocalSettings('printerId', ev.target.value)}
                    disabled={!localSettings.printViaService}
                  />
                </Grid>
                <Grid item xs={10}>
                  <Typography >Etikettendruck</Typography>
                </Grid>
                <Grid
                  item
                  xs={2}
                  className={classes.switchContainer}
                >
                  <Switch
                    checked={localSettings.labelPrinting}
                    onChange={ev => changeLocalSettings('labelPrinting', ev.target.checked)}
                    color="primary"
                  />
                </Grid>
                </>
              ) : null}
            <Grid item xs={12}>
              <Typography className={classes.heading}>Bestellungen</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography >Dauerton & Popup bei neuer Bestellung</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={!!localSettings.openAlertForNewOrder}
                onChange={ev => changeLocalSettings('openAlertForNewOrder', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography >Fehlerton wenn keine Bestellung gefunden</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={!!localSettings.playSoundOnNoOrderFound}
                onChange={ev => changeLocalSettings('playSoundOnNoOrderFound', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={6}>
              <Typography >Signalton</Typography>
            </Grid>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="flex-end"
              xs={6}
            >
              <FormControl className={classes.formControl}>
                <Select
                  value={localSettings.soundName || soundOptions[0].name}
                  onChange={ev => changeLocalSettings('soundName', ev.target.value)}
                >
                  {soundOptions.map(option => (<MenuItem key={option.name} value={option.name}>{option.title}</MenuItem>)) }
                </Select>
              </FormControl>
              <Button
                variant="transparent"
                onClick={() => {
                  requestAnimationFrame(() => {
                    playSound();
                  });
                }}
              >
                <VolumeUpIcon />
              </Button>
            </Grid>
            <Grid item xs={10}>
              <Typography >Mobile Listenansicht</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={!localSettings.disableMobileList}
                onChange={ev => changeLocalSettings('disableMobileList', !ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography >Alle Bestellungen drucken anzeigen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showPrintAllOrders}
                onChange={ev => changeLocalSettings('showPrintAllOrders', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.heading}>Preise</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography >Gesamtpreise anzeigen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showTotalPrice}
                onChange={ev => changeLocalSettings('showTotalPrice', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography >Artikelpreise anzeigen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showArticlePrice}
                onChange={ev => changeLocalSettings('showArticlePrice', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography >Trinkgeld anzeigen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showTip}
                onChange={ev => changeLocalSettings('showTip', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography >Veranstaltung anzeigen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showEventName}
                onChange={ev => changeLocalSettings('showEventName', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.heading}>Verlauf</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography >Verlauf anzeigen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showOrderHistory}
                onChange={ev => changeLocalSettings('showOrderHistory', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography >Verlauf zurücksetzen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <IconButton
                onClick={() => resetOrderHistory()}
              >
                <RotateLeftIcon />
              </IconButton>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.heading}>Zukünftige Bestellungen anzeigen</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography >Morgen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showTomorrow}
                onChange={ev => changeLocalSettings('showTomorrow', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography >Übermorgen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showSecondNextDay}
                onChange={ev => changeLocalSettings('showSecondNextDay', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography >Abholung nur am selben Tag erlauben</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.restrictPickupToToday}
                onChange={ev => changeLocalSettings('restrictPickupToToday', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Abholung via Scan nur innerhalb von 2 Stunden zu Abholzeitpunkt </Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.restrictScanToPickupTimeWindow}
                onChange={ev => changeLocalSettings('restrictScanToPickupTimeWindow', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.heading}>Suche</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography>Suche automatisch zurücksetzen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.resetSearch}
                onChange={ev => changeLocalSettings('resetSearch', ev.target.checked)}
                color="primary"
              />
            </Grid>
            {localSettings.resetSearch && (
              <Grid>
                <TextField
                  placeholder="In Sekunden"
                  value={localSettings.resetSearchValue}
                  onChange={e => changeLocalSettings('resetSearchValue', e.target.value)}
                  style={{ flexGrow: 1, paddingLeft: 10, float: 'left' }}
                />
              </Grid>
            )}
            <Grid item xs={10}>
              <Typography>Automatisch weiter nach Scan</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.autoNextOnScan}
                onChange={ev => changeLocalSettings('autoNextOnScan', ev.target.checked)}
                color="primary"
              />
            </Grid>
            {
              localSettings.autoNextOnScan && (
                <>
                  <Grid item xs={10}>
                    <Typography>Automatisch weiter nur am aktuellen Tag erlauben</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    className={classes.switchContainer}
                  >
                    <Switch
                      checked={localSettings.restrictAutoNextOnScanToToday}
                      onChange={ev => changeLocalSettings('restrictAutoNextOnScanToToday', ev.target.checked)}
                      color="primary"
                    />
                  </Grid>
                </>
              )
            }
            {localSettings.autoNextOnScan && (
              <Grid>
                <TextField
                  placeholder="Automatisch weiter in Sekunden"
                  value={localSettings.autoNextTimeout || 4}
                  onChange={e => changeLocalSettings('autoNextTimeout', e.target.value)}
                  style={{ flexGrow: 1, paddingLeft: 10, float: 'left' }}
                />
              </Grid>
            )}
            <Grid item xs={10}>
              <Typography>Suche via Kamera aktivieren</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showQrScanButton}
                onChange={ev => changeLocalSettings('showQrScanButton', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Bestellungen bei Kundenscan hervorheben</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.selectOrdersOnUserMatch}
                onChange={ev => changeLocalSettings('selectOrdersOnUserMatch', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography className={classes.heading}>Routenplanung</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.enableRouteplanning}
                onChange={ev => changeLocalSettings('enableRouteplanning', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Adresse in Übersicht anzeigen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showDeliveryAdressInline}
                onChange={ev => changeLocalSettings('showDeliveryAdressInline', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Ninjas Weiterleitung</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showOrderExport}
                onChange={ev => changeLocalSettings('showOrderExport', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography className={classes.heading}>Sidebar</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showSidebar}
                onChange={ev => changeLocalSettings('showSidebar', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography className={classes.heading}>Bestell-Tickets</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showTickets}
                onChange={ev => changeLocalSettings('showTickets', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.heading}>Filter</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography>Filter für Produktionsplatz</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showProductionPlaceFilter}
                onChange={ev => changeLocalSettings('showProductionPlaceFilter', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Filter für Abholstandorte / Tische</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.showOrderSpotFilter}
                onChange={ev => changeLocalSettings('showOrderSpotFilter', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Produktionsplätze zusammenfassen</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.combineProductionPlaces}
                onChange={ev => changeLocalSettings('combineProductionPlaces', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Beilagen in Summenleiste aufsplitten</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.splitSideDishes}
                onChange={ev => changeLocalSettings('splitSideDishes', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Artikel in Summenleiste nach Beilage aufsplitten</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.sideDishGroups}
                onChange={ev => changeLocalSettings('sideDishGroups', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Summenleiste nach Status aufsplitten</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.splitByState}
                onChange={ev => changeLocalSettings('splitByState', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.heading}>Sortierung</Typography>
            </Grid>
            <Grid item xs={10}>
              <Typography>Alphabetisch nach Tisch</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.switchContainer}
            >
              <Switch
                checked={localSettings.sortSpotAlphabetical}
                onChange={ev => changeLocalSettings('sortSpotAlphabetical', ev.target.checked)}
                color="primary"
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                label="Farbcode für Bestellungen mit Preis"
                value={localSettings.nonZeroPriceColor}
                onChange={ev => changeLocalSettings('nonZeroPriceColor', ev.target.value)}                
              />
            </Grid>
          </Grid>

        </div >
      </DialogContent>
      <DialogActions>
        {backButton}
      </DialogActions>
    </Dialog>
  );
}


const styles = theme => ({
  actionContainer: {
    display: 'flex',
    justifyContent: 'center',
    position: 'sticky',
    bottom: '0px',
    margin: '5px',
  },
  heading: {
    fontWeight: 'bold',
  },
  switchContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});


SettingsDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  localSettings: PropTypes.object.isRequired,
  changeLocalSettings: PropTypes.func.isRequired,
  resetOrderHistory: PropTypes.func.isRequired,
  proceedAllVisibleOrders: PropTypes.func.isRequired,
};

SettingsDialog.defaultProps = {
};


export default withStyles(styles)(SettingsDialog);

